<template>
  <div class="l-page l-page--message">
    <!-- サイドバーエリア -->
    <page-sidebar />
    <!-- /サイドバーエリア -->
    <main class="l-main">
      <div class="l-main-head">
        <div class="c-title u-w600">
          <div class="c-title__text c-title__text--blue u-fs34">アカウントの一覧</div>
        </div>
      </div>
      <div class="l-main-content">
        <div class="p-message-result">
          <div class="p-message-search">
            <div class="p-message-search-keyword">
              <div class="c-input u-w480">
                <input
                  class="c-input__item c-input__item--overlay-ico"
                  name="push_name"
                  placeholder="アカウントIDまたはアカウント名で検索できます"
                  type="text"
                  :value="params.searchQuery"
                  @input="onChangeSearchAccount"
                  @keydown.enter="onSearchAccount"
                />
                <div class="c-input__icon c-input__icon--overlay" @click="onSearchAccount">
                  <div class="c-icon c-icon--white u-wh30">
                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                      <use xlink:href="/assets/img/sprite.svg#search" />
                    </svg>
                  </div>

                </div>
                <div class="c-error c-error--balloon">
                  <div class="c-error__text"></div>
                </div>
              </div>
              <button type="button" class="c-btn c-btn--gray u-w140 u-h32 u-fs--s" @click="onClickCSVDownload"><p class="c-btn__text">CSVダウンロード</p></button>
            </div>
          </div>
          <div class="p-message-result__data">
            <div class="c-error">
              <div class="c-error__txt">アカウントが存在しません</div>
            </div>
            <table class="c-table">
              <thead>
                <tr>
                  <th class="c-table__cell--center u-w120 is-sortable">
                    <span class="c-table__text">アカウントID</span>
                    <span class="c-btn c-btn--sort" data-type="account_id"></span>
                  </th>
                  <th class="c-table__cell--center is-sortable">
                    <span class="c-table__text">アカウント名</span>
                    <span class="c-btn c-btn--sort" data-type="account_name"></span>
                  </th>
                  <th class="c-table__cell--center u-w200">
                    <span class="c-table__text">略称</span>
                    <span class="c-btn c-btn--sort" data-type="account_name_short"></span>
                  </th>
                  <th class="c-table__cell--center u-w200">
                    <span class="c-table__text">状態</span>
                    <span class="c-btn c-btn--sort" data-type="suspend_flag"></span>
                  </th>
                </tr>
              </thead>
              <tbody class="is-editable">
                <tr v-for="(value, key) in accounts" :key="key">
                  <td class="c-table__cell--center c-table__cell--middle u-w120">{{ value.account_id }}</td>
                  <td class="c-table__cell--middle">{{ value.account_name }}</td>
                  <td class="c-table__cell--middle u-w200">{{ value.account_name_short }}</td>
                  <td class="c-table__cell--center c-table__cell--middle u-h70 u-w200">
                    <p>{{ getAccountStatusLabel(value.suspend_flag) }}</p>
                    <div class="c-table-editable">
                      <ul class="c-table-editable-list">
                        <li class="c-table-editable-list__item">
                          <a class="c-btn c-btn--white c-btn--circle" @click="onClickShowAccountUserEdit(value.account_id)">
                            <div class="c-btn__text c-btn__text--balloon">ユーザー管理</div>
                            <div class="c-icon c-icon--gray-3 u-wh20">
                              <svg
                                version="1.1"
                                xmlns="http://www.w3.org/2000/svg"
                                xmlns:xlink="http://www.w3.org/1999/xlink"
                              >
                                <use xlink:href="/assets/img/sprite.svg#user" />
                              </svg>
                            </div>
                          </a>
                        </li>
                        <li v-show="!value.is_system_admin" class="c-table-editable-list__item">
                          <a class="c-btn c-btn--white c-btn--circle" @click="onClickShowAccountEdit(value.account_id)">
                            <div class="c-btn__text c-btn__text--balloon">詳細を表示する</div>
                            <div class="c-icon c-icon--gray-3 u-wh20">
                              <svg
                                version="1.1"
                                xmlns="http://www.w3.org/2000/svg"
                                xmlns:xlink="http://www.w3.org/1999/xlink"
                              >
                                <use xlink:href="/assets/img/sprite.svg#review" />
                              </svg>
                            </div>
                          </a>
                        </li>
                        <li v-show="!value.is_system_admin" class="c-table-editable-list__item">
                          <a class="c-btn c-btn--white c-btn--circle" @click="onClickDeleteAccount(value.account_id, value.account_name)">
                            <div class="c-btn__text c-btn__text--balloon">削除する</div>
                            <div class="c-icon c-icon--gray-3 u-wh20">
                              <svg
                                version="1.1"
                                xmlns="http://www.w3.org/2000/svg"
                                xmlns:xlink="http://www.w3.org/1999/xlink"
                              >
                                <use xlink:href="/assets/img/sprite.svg#trash" />
                              </svg>
                            </div>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </main>

    <!-- モーダル: アカウント削除確認 -->
    <control-modal
      ref="refDeleteUserModal"
      classes="c-modal--common"
      title="以下のアカウントを削除しますか?"
      :body="`${deleteAccountName}`"
      cancel-button-label="キャンセル"
      enter-button-label="削除する"
      :is-active=isDeleteUser
      :on-close-click="onCloseDeleteUserModal"
      :on-cancel-click="onCloseDeleteUserModal"
      :on-enter-click="onEnterDeleteUserModal"
    />

  </div>
</template>

<script>
import axios from "axios";
export default {
  props: {
    accounts: Array,
    breadcrumbData: Array,
  },

  data() {
    return {
      deleteAccountId: '',
      deleteAccountName: '',
      isDeleteUser: false,
      params: {
        searchQuery: '',
      }
    };
  },
  mounted: function() {
    let searchParams = new URLSearchParams(location.search);
    this.params.searchQuery = searchParams.get('query') ? searchParams.get('query') : '';
  },
  methods: {
    // -----------------------------------------------------------------------------------------------------
    // イベント系メソッド一覧: UI操作にフックしてコールされるメソッド
    // -----------------------------------------------------------------------------------------------------
    onSearchAccount: function() {
      location.href = '/coins-admin/account?query=' + this.params.searchQuery;
    },

    onChangeSearchAccount: function(event) {
      this.params.searchQuery = event.target.value;
    },

    onClickShowNewAccount: function() {
      location.href = '/coins-admin/account/new';
    },

    onClickShowAccountEdit: function(accountId) {
      location.href = '/coins-admin/account/' + accountId;
    },
    onClickShowAccountUserEdit: function(accountId) {
      location.href = '/coins-admin/account/' + accountId + '/users';
    },

    onClickDeleteAccount: function(accountId, accountName) {
      this.isDeleteUser = true;
      this.deleteAccountName = accountName;
      this.deleteAccountId = accountId;
    },

    // -----------------------------------------------------------------------------------------------------
    // エミット系メソッド一覧: 子孫のUI操作にフックエミットコールされるか、引き渡した関数オブジェクトからコールされるメソッド
    // -----------------------------------------------------------------------------------------------------
    // クリック: 操作モーダル（アカウント削除）を閉じる処理
    onCloseDeleteUserModal() {
      this.isDeleteUser = false
      this.errorMessage = ''
      this.$refs.refDeleteUserModal.resetErrorMessage();
    },

    // クリック: 操作モーダル（アカウント削除）を閉じる処理
    onEnterDeleteUserModal() {
      this.$refs.refDeleteUserModal.showLoader();
      axios
        .delete('/api/accounts/' + this.deleteAccountId)
        .then((_res) => {
          // TODO: UI
          this.$refs.refDeleteUserModal.hideLoader();
          location.reload();
        })
        .catch((_error) => {
          this.$refs.refDeleteUserModal.hideLoader();
          this.$refs.refDeleteUserModal.showErrorMessage('アカウントを削除出来ませんでした');

        });
    },

    onClickCSVDownload() {
      location.href = '/coins-admin/account/download';
    },

    // -----------------------------------------------------------------------------------------------------
    // その他
    // -----------------------------------------------------------------------------------------------------
    getAccountStatusLabel(status) {
      if (status == 1) {
        return '停止中';
      }
      return '利用中';
    }
  }
};
</script>
